import { put,call } from "redux-saga/effects";

import axios from '../../services/axios-service';
import * as actions from "../actions";
import ConsoleLog from '../../hoc/ConsoleLog/ConsoleLog';
import getS3ImageUrl from '../../lib/s3FileHandler';

/**
* @desc saga for candidate review
* @version
* @author Lakshmikanth 
* @return api response
*/
export function* getGroupTalentPoolsSaga(action) {
  try {
    const response = yield axios.get(
      "/galaxy/job/" + action.jobTitleId + "/candidate?group=1&isClientList=1");
      const dataArray = response.data.items;
      for (var element in dataArray) {
        for(let i=0; i< dataArray[element].length; i++){ 
          if(dataArray[element][i].candidate_image){
          const candidateImageResponse = yield call(getS3ImageUrl,dataArray[element][i].candidate_image,action.user);
          dataArray[element][i].s3SignedUrl= candidateImageResponse;
        }
      }
      };
    yield put(actions.setGroupedTalentPool(dataArray));
  } catch (error) {
     ConsoleLog(error);
  }
}

export function* updateCandidatePrioritySaga(action) {
  const data = {
    sortCids: action.candidateIdList,
    jobId: action.jobId,
    sort: 1
  }
  try {
    const response = yield axios.post(
      "/galaxy/client/candidate",JSON.stringify(data)); 
  } catch (error) {
     ConsoleLog(error);
  }
}


// WEBPACK FOOTER //
// ./src/store/sagas/candidateReview.js